{
  "nl": {
    "notification": {
      "actions": {
        "delete": "Verwijder notificatie",
        "deleteAll": "Verwijder alles",
        "markAllAsRead": "Alles markeren als gelezen",
        "mark_as_read": "Markeer als gelezen",
        "mark_as_unread": "Markeer als ongelezen"
      },
      "customers": {
        "announcement": {
          "create": "heeft een nieuwsbericht geplaatst. | heeft {group_notification_count} nieuwsberichten geplaatst. |_| hebben {group_notification_count} nieuwsberichten geplaatst."
        },
        "decision": {
          "message": {
            "create": "heeft een bericht gestuurd in beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} berichten gestuurd in beslissing <i>'{group_name}'</i>. | _ | hebben {group_notification_count} berichten gestuurd in beslissing <i>'{group_name}'</i>."
          },
          "published": {
            "customer": "heeft beslissing <i>'{notifiable_name}'</i> toegevoegd."
          },
          "relaunched": "heeft de beslissing <i>'{notifiable_name}'</i> weer beschikbaar gemaakt."
        },
        "decision_document": {
          "create": "heeft document <i>'{notifiable_name}'</i> geüpload voor beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} documenten geüpload voor beslissing <i>'{group_name}'</i>. |_| hebben {group_notification_count} documenten geüpload voor beslissing <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "heeft voorstel <i>'{notifiable_name}'</i> aanvaard voor beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} voorstellen aanvaard voor beslissing <i>'{group_name}'</i>. |_| hebben {group_notification_count} voorstellen aanvaard voor beslissing <i>'{group_name}'</i>.",
          "create": "heeft voorstel <i>'{notifiable_name}'</i> aangemaakt voor beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} voorstellen aangemaakt voor beslissing <i>'{group_name}'</i>. |_| hebben {group_notification_count} voorstellen aangemaakt voor beslissing <i>'{group_name}'</i>.",
          "edit_approved": "heeft het aanvaarde voorstel <i>'{notifiable_name}'</i> aangepast voor beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} aanvaarde voorstellen aangepast voor beslissing <i>'{group_name}'</i>. |_| hebben {group_notification_count} aanvaarde voorstellen aangepast voor beslissing <i>'{group_name}'</i>.",
          "relaunched": "heeft het afgewezen voorstel <i>'{notifiable_name}'</i> terug beschikbaar gemaakt | heeft {group_notification_count} afgewezen voorstellen in beslissing <i>'{group_name}'</i> terug beschikbaar gemaakt | heeft {group_notification_count} afgewezen voorstellen in beslissing <i>'{group_name}'</i> terug beschikbaar gemaakt"
        },
        "document": {
          "create": "heeft document <i>'{notifiable_name}'</i> geüpload. | heeft {group_notification_count} documenten geüpload. |_| hebben {group_notification_count} documenten geüpload.",
          "installment": {
            "create": "heeft factuur <i>'{notifiable_name}'</i> toegevoegd aan een betalingsschijf. | heeft {group_notification_count} facturen toegevoegd aan een betalingsschijf. |_| hebben {group_notification_count} facturen toegevoegd aan een betalingsschijf."
          },
          "invoice": {
            "create": "heeft factuur <i> '{notifiable_name}' </i> geüpload. | heeft {group_notification_count} facturen geüpload. |_| hebben {group_notification_count} facturen geüpload."
          },
          "proposal": {
            "create": "heeft document <i>'{notifiable_name}'</i> toegevoegd aan voorstel <i>'{group_name}'</i>. | heeft {group_notification_count} documenten toegevoegd aan voorstel <i>'{group_name}'</i>. |_| heeft {group_notification_count} documenten toegevoegd aan voorstel <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Jouw exportdata is klaar om gedownload te worden."
        },
        "installment": {
          "published": "heeft betalingsschijf <i>'{notifiable_name}'</i> beschikbaar gemaakt. | heeft {group_notification_count} termijnen beschikbaar gemaakt. | heeft {group_notification_count} termijnen beschikbaar gemaakt.",
          "status": {
            "changed": "heeft de status van betalingsschijf <i>'{notifiable_name}'</i> gewijzigd in <i>'{status}'</i>. | heeft de status van {group_notification_count} termijnen gewijzigd. | heeft de status van {group_notification_count} termijnen gewijzigd."
          }
        },
        "issue": {
          "approval": {
            "create": "vraagt jouw goedkeuring voor het punt <i>'{notifiable_name}'</i> | vraagt jouw goedkeuring voor {group_notification_count} punten. |_| vraagt jouw goedkeuring voor {group_notification_count} punten."
          },
          "create": "heeft het punt <i>'{notifiable_name}'</i> aangemaakt | heeft {group_notification_count} punten aangemaakt voor <i>'{group_name}'</i> |_| heeft {group_notification_count} punten aangemaakt voor <i>'{group_name}'</i>",
          "message": {
            "create": "heeft een bericht geplaatst in gesprek <i>'{group_name}'</i>. | heeft {group_notification_count} berichten geplaatst in gesprek <i>'{group_name}'</i>. |_| hebben {group_notification_count} berichten geplaatst in gesprek <i>'{group_name}'</i>."
          },
          "status": {
            "update": "heeft de status van <i>'{notifiable_name}'</i> veranderd naar <i>'{status}'</i> | heeft de status van {group_notification_count} punten aangepast. |_| heeft de status van {group_notification_count} punten aangepast."
          }
        },
        "question": {
          "create": "heeft de vraag <i>'{notifiable_name}'</i> toegevoegd aan FAQ <i>'{group_name}'</i>. | heeft {group_notification_count} vragen toegevoegd aan FAQ <i>'{group_name}'</i>. |_| hebben {group_notification_count} vragen toegevoegd aan FAQ <i>'{group_name}'</i>."
        },
        "reminder": {
          "decision": {
            "due": "Vergeet niet een beslissing te nemen voor <i>\"{notifiable_name}\"</i>."
          },
          "installment": {
            "due": "Vergeet niet te betalen voor <i>\"{notifiable_name}\"</i>."
          }
        },
        "survey": {
          "published": "zou graag feedback willen over <i>'{group_name}'</i>."
        },
        "ticket": {
          "create": "heeft een gesprek gestart met onderwerp <i>'{notifiable_name}'</i>.",
          "message": {
            "create": "heeft een bericht geplaatst in gesprek <i>'{group_name}'</i>. | heeft {group_notification_count} berichten geplaatst in gesprek <i>'{group_name}'</i>. |_| hebben {group_notification_count} berichten geplaatst in gesprek <i>'{group_name}'</i>.",
            "move": "heeft je bericht verplaatst naar gesprek <i>'{group_name}'</i>"
          }
        },
        "ticket_document": {
          "create": "heeft document <i>'{notifiable_name}'</i> in gesprek <i>'{group_name}'</i> geüpload. | heeft {group_notification_count} documenten in gesprek <i>'{group_name}'</i> geüpload. |_| heeft {group_notification_count} documenten in gesprek <i>'{group_name}'</i> geüpload."
        }
      },
      "employees": {
        "announcement": {
          "create": "heeft een nieuwsbericht geplaatst. | heeft {group_notification_count} nieuwsberichten geplaatst in <i>'{group_name}'</i>. |_| hebben {group_notification_count} nieuwsberichten geplaatst in <i>'{group_name}'</i>."
        },
        "decision": {
          "mention": {
            "create": "noemde je in gesprek <i>'{group_name}'</i>. | noemde je in {group_notification_count} berichten in gesprek <i>'{group_name}'</i>. |_| genoemd in {group_notification_count} berichten in gesprek <i>'{group_name}'</i>."
          },
          "message": {
            "create": "heeft een bericht gestuurd in beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} berichten gestuurd in beslissing <i>'{group_name}'</i>. |_| hebben {group_notification_count} berichten gestuurd in beslissing <i>'{group_name}'</i>."
          },
          "not_interested": "is niet geïnteresseerd in beslissing <i>'{notifiable_name}'</i>.",
          "responsible": {
            "update": "heeft jou de nieuwe verantwoordelijke gemaakt van beslissing <i>'{notifiable_name}'</i>"
          }
        },
        "decision_document": {
          "create": "heeft document <i>'{notifiable_name}'</i> geüpload voor beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} documenten geüpload voor beslissing <i>'{group_name}'</i>. |_| hebben {group_notification_count} documenten geüpload voor beslissing <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "heeft voorstel <i>'{notifiable_name}'</i> aanvaard voor beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} voorstellen aanvaard voor beslissing <i>'{group_name}'</i>. |_| hebben {group_notification_count} voorstellen aanvaard voor beslissing <i>'{group_name}'</i>.",
          "create": "heeft voorstel <i>'{notifiable_name}'</i> aangemaakt voor beslissing <i>'{group_name}'</i>. | heeft voorstellen aangemaakt voor beslissing <i>'{group_name}'</i>. |_| hebben voorstellen <i>'{notifiable_name}'</i> aangemaakt voor beslissing <i>'{group_name}'</i>.",
          "requested_changes": "heeft het voorstel <i>'{notifiable_name}'</i> afgewezen in beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} voorstellen afgewezen in beslissing <i>'{group_name}'</i>. |_| heeft {group_notification_count} voorstellen afgewezen in beslissing <i>'{group_name}'</i>."
        },
        "document": {
          "create": "heeft document <i>'{notifiable_name}'</i> geüpload in folder <i>'{group_name}'</i>. | heeft {group_notification_count} documenten geüpload in folder <i>'{group_name}'</i>. |_| hebben {group_notification_count} documenten geüpload in folder <i>'{group_name}'</i>.",
          "proposal": {
            "create": "heeft document <i>'{notifiable_name}'</i> toegevoegd aan voorstel <i>'{group_name}'</i>. | heeft {group_notification_count} documenten toegevoegd aan voorstel <i>'{group_name}'</i>. |_| heeft {group_notification_count} documenten toegevoegd aan voorstel <i>'{group_name}'</i>."
          }
        },
        "email_conversation": {
          "client": {
            "create": "heeft een inkomende e-mail ontvangen <i>'{notifiable_name}'</i>. | heeft {group_notification_count} inkomende e-mails ontvangen. |_| heeft {group_notification_count} inkomende e-mails ontvangen."
          },
          "project": {
            "create": "heeft een inkomende e-mail ontvangen <i>'{notifiable_name}'</i>. | heeft {group_notification_count} inkomende e-mails ontvangen. |_| heeft {group_notification_count} inkomende e-mails ontvangen."
          }
        },
        "export": {
          "create": "Jouw exportdata is klaar om gedownload te worden."
        },
        "issue": {
          "approved": "heeft punt <i>'{notifiable_name}'</i> goedgekeurd voor <i>'{level_name}'</i>. | heeft {group_notification_count} punten goedgekeurd</i>. |_| heeft {group_notification_count} punten goedgekeurd.",
          "create": "heeft een nieuw punt gemaakt voor unit <i>{level_name}</i> | creëerde {group_notification_count} punten voor <i>{level_name}</i> |_| creëerde {group_notification_count} nieuwe punten voor <i>{level_name}</i>",
          "mention": {
            "create": "noemde je in gesprek <i>'{group_name}'</i>. | noemde je in {group_notification_count} berichten in gesprek <i>'{group_name}'</i>. |_| genoemd in {group_notification_count} berichten in gesprek <i>'{group_name}'</i>."
          },
          "message": {
            "create": "heeft een bericht gestuurd in gesprek <i>'{group_name}'</i>. | heeft {group_notification_count} berichten gestuurd in gesprek <i>'{group_name}'</i>. |_| hebben {group_notification_count} berichten gestuurd in gesprek <i>'{group_name}'</i>."
          },
          "rejected": "heeft punt <i>'{notifiable_name}'</i> afgewezen voor <i>'{level_name}'</i>. | heeft {group_notification_count} punten afgewezen</i>. |_| heeft {group_notification_count} punten afgewezen."
        },
        "question": {
          "create": "heeft de vraag <i>'{notifiable_name}'</i> toegevoegd aan FAQ <i>'{group_name}'</i>. | heeft {group_notification_count} vragen toegevoegd aan FAQ <i>'{group_name}'</i>. |_| hebben {group_notification_count} vragen toegevoegd aan FAQ <i>'{group_name}'</i>."
        },
        "survey_answer": {
          "create": "heeft <i>'{group_name}'</i> beantwoord."
        },
        "ticket": {
          "create": "heeft een gesprek gestart met onderwerp <i>'{notifiable_name}'</i>.",
          "mention": {
            "create": "heeft je vermeld in gesprek <i>'{group_name}'</i>. | heeft je vermeld in {group_notification_count} berichten in gesprek <i>'{group_name}'</i>. |_| heeft je vermeld in {group_notification_count} berichten in gesprek <i>'{group_name}'</i>."
          },
          "message": {
            "create": "heeft een bericht gestuurd in gesprek <i>'{group_name}'</i>. | heeft {group_notification_count} berichten gestuurd in gesprek <i>'{group_name}'</i>. |_| hebben {group_notification_count} berichten gestuurd in gesprek <i>'{group_name}'</i>."
          },
          "responsible": {
            "update": "heeft jou verantwoordelijk gemaakt voor het gesprek <i>'{notifiable_name}'</i>."
          }
        },
        "ticket_document": {
          "create": "heeft document <i>'{notifiable_name}'</i> in gesprek <i>'{group_name}'</i> geüpload. | heeft {group_notification_count} documenten in gesprek <i>'{group_name}'</i> geüpload. |_| heeft {group_notification_count} documenten in gesprek <i>'{group_name}'</i> geüpload."
        },
        "todo": {
          "assign": "heeft de taak <i>'{notifiable_name}'</i> aan jou toegewezen in de lijst <i>'{group_name}'</i>. | heeft {group_notification_count} taken aan jou toegewezen in de lijst <i>'{group_name}'</i>. | hebben de taak <i>'{notifiable_name}'</i> aan jou toegewezen in de lijst <i>'{group_name}'</i>. | hebben {group_notification_count} taken aan jou toegewezen in de lijst <i>'{group_name}'</i>."
        }
      },
      "labels": {
        "all": "Alle projecten",
        "allDecisions": "Alle beslissingen",
        "allStatuses": "Alles",
        "filter": "Filteren",
        "hideDecisionFilter": "Verberg beslissingsfilter",
        "hideExtraFilters": "Extra filters verbergen",
        "noNewNotification": "Geen nieuwe notificaties",
        "noResults": "Geen resultaat. Probeer iets anders!",
        "none": "Je hebt momenteel geen notificaties.",
        "notification_level_name_asc": "Unit A->Z",
        "notification_level_name_desc": "Unit Z->A",
        "pinSidebar": "Vastzetten",
        "showDecisionFilter": "Toon beslissingsfilter",
        "showExtraFilters": "Extra filters tonen",
        "sort": "Sorteer op",
        "status": "Status",
        "unpinSidebar": "Loskoppelen",
        "unreadOnly": "Enkel ongelezen",
        "updated_at_asc": "Oudste eerst",
        "updated_at_desc": "Nieuwste eerst"
      },
      "other_user": "en 1 andere",
      "other_users": "en 1 andere | en {count} anderen",
      "partners": {
        "decision": {
          "message": {
            "create": "heeft een bericht gestuurd in gesprek <i>'{group_name}'</i>. | heeft {group_notification_count} berichten gestuurd in gesprek <i>'{group_name}'</i>. |_| hebben {group_notification_count} berichten gestuurd in gesprek <i>'{group_name}'</i>."
          },
          "not_interested": "is niet geïnteresseerd in beslissing <i>'{notifiable_name}'</i>.",
          "published": {
            "partners": "heeft beslissing <i>'{notifiable_name}'</i> aangemaakt. | heeft {group_notification_count} <i>'{group_name}'</i> beslissingen aangemaakt. |_| hebben {group_notification_count} <i>'{group_name}'</i> beslissingen aangemaakt."
          }
        },
        "decision_document": {
          "create": "heeft document <i>'{notifiable_name}'</i> geüpload voor beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} documenten geüpload voor beslissing <i>'{group_name}'</i> |_| hebben {group_notification_count} documenten geüpload voor beslissing <i>'{group_name}'</i>"
        },
        "decision_proposal": {
          "approved": "heeft voorstel <i>'{notifiable_name}'</i> aanvaard voor beslissing <i>'{group_name}'</i>. | heeft een voorstel aanvaard voor beslissing <i>'{group_name}'</i>. | hebben een voorstel aanvaard voor beslissing <i>'{group_name}'</i>. | hebben voorstellen aanvaard voor beslissing <i>'{group_name}'</i>.",
          "create": "heeft voorstel <i>'{notifiable_name}'</i> aangemaakt voor beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} voorstellen aangemaakt voor beslissing <i>'{group_name}'</i>. |_| hebben {group_notification_count} voorstellen aangemaakt voor beslissing <i>'{group_name}'</i>.",
          "requested_changes": "heeft het voorstel <i>'{notifiable_name}'</i> afgewezen in beslissing <i>'{group_name}'</i>. | heeft {group_notification_count} voorstellen afgewezen in beslissing <i>'{group_name}'</i>. |_| heeft {group_notification_count} voorstellen afgewezen in beslissing <i>'{group_name}'</i>."
        },
        "document": {
          "proposal": {
            "create": "heeft document <i>'{notifiable_name}'</i> toegevoegd aan voorstel <i>'{group_name}'</i>. | heeft {group_notification_count} documenten toegevoegd aan voorstel <i>'{group_name}'</i>. |_| heeft {group_notification_count} documenten toegevoegd aan voorstel <i>'{group_name}'</i>."
          }
        },
        "export": {
          "create": "Jouw exportdata is klaar om gedownload te worden."
        },
        "issue": {
          "status": {
            "update": "heeft de status van een punt in <i>'{group_name}'</i> aangepast. | heeft de status van {group_notification_count} punten in <i>'{group_name}'</i> aangepast. |_| heeft de status van {group_notification_count} punten in <i>'{group_name}'</i> aangepast."
          }
        },
        "issue_list": {
          "published": "publiceerde een puntenlijst <i>'{notifiable_name}'</i> | publiceerde de puntenlijst <i>'{notifiable_name}'</i> voor {group_notification_count} units |_| publiceerde de puntenlijst <i>'{notifiable_name}'</i> voor {group_notification_count} units"
        },
        "reminder": {
          "due": "Vergeet beslissing <i>'{notifiable_name}'</i> voor unit {level_name} niet."
        },
        "ticket_document": {
          "create": "geüpload document <i>'{notifiable_name}'</i> in gesprek <i>'{group_name}'</i>. | geüpload {group_notification_count} documenten in gesprek <i>'{group_name}'</i>. |_| geüpload {group_notification_count} documenten in gesprek <i>'{group_name}'</i>."
        },
        "unit": {
          "visibled": "heeft klant <i>'{customer_group_name}'</i> toegevoegd aan beslissing <i>'{group_name}'</i> voor unit <i>'{notifiable_name}'</i>."
        }
      },
      "title": "Notificaties"
    }
  }
}